const cat = [
  {
    path: '/tickets',
    name: 'tickets',
    component: () => import('@/views/tickets/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets',
      resource: 'all',
    },
  },
  {
    path: '/tickets/template',
    name: 'tickets-template',
    component: () => import('@/views/tickets/TemplatePage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets_template',
      resource: 'all',
    },
  },
  {
    path: '/tickets/showTicket/:id',
    name: 'show_ticket',
    component: () => import('@/views/tickets/showTicket.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets',
      resource: 'all',
    },
  },
  {
    path: '/tickets/report',
    name: 'tickets-report',
    component: () => import('@/views/tickets/ReportPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets_report',
      resource: 'all',
    },
  },
  {
    path: '/tickets/report-admin',
    name: 'tickets-report-admin',
    component: () => import('@/views/tickets/ReportAdminPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets_report',
      resource: 'all',
    },
  },
]

export default cat
